import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const EmptyStateEmbedded = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <SvgIcon
    data-test="empty-state-illustration-embedded"
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    {...props}
  >
    <path
      d="M13 64.2C13 70.9237 14.3243 77.5815 16.8974 83.7934C19.4704 90.0053 23.2418 95.6495 27.9961 100.404C32.7505 105.158 38.3947 108.93 44.6066 111.503C50.8185 114.076 57.4763 115.4 64.2 115.4C70.9237 115.4 77.5815 114.076 83.7934 111.503C90.0053 108.93 95.6495 105.158 100.404 100.404C105.158 95.6495 108.93 90.0053 111.503 83.7934C114.076 77.5815 115.4 70.9237 115.4 64.2C115.4 57.4763 114.076 50.8185 111.503 44.6066C108.93 38.3947 105.158 32.7505 100.404 27.9961C95.6495 23.2418 90.0053 19.4704 83.7934 16.8974C77.5815 14.3243 70.9237 13 64.2 13C57.4763 13 50.8185 14.3243 44.6066 16.8974C38.3947 19.4704 32.7505 23.2418 27.9961 27.9961C23.2418 32.7505 19.4704 38.3947 16.8974 44.6066C14.3243 50.8185 13 57.4763 13 64.2Z"
      fill="#F5F4F4"
    />
    <path
      d="M40 102.68C40 103.21 42.4232 103.719 46.7365 104.094C51.0499 104.469 56.9 104.68 63 104.68C69.1 104.68 74.9501 104.469 79.2634 104.094C83.5768 103.719 86 103.21 86 102.68C86 102.149 83.5768 101.641 79.2634 101.265C74.9501 100.89 69.1 100.68 63 100.68C56.9 100.68 51.0499 100.89 46.7365 101.265C42.4232 101.641 40 102.149 40 102.68Z"
      fill="#E0DEDF"
    />
    <rect
      x="24"
      y="39.6797"
      width="34"
      height="62"
      rx="2"
      fill="#FDF5FF"
      stroke="#6A266D"
      strokeWidth="1.25"
    />
    <path
      d="M38 96.8844C38 97.5696 38.2726 98.2268 38.7578 98.7113C39.243 99.1958 39.9011 99.468 40.5872 99.468C41.2734 99.468 41.9315 99.1958 42.4167 98.7113C42.9019 98.2268 43.1744 97.5696 43.1744 96.8844C43.1744 96.1992 42.9019 95.542 42.4167 95.0575C41.9315 94.573 41.2734 94.3008 40.5872 94.3008C39.9011 94.3008 39.243 94.573 38.7578 95.0575C38.2726 95.542 38 96.1992 38 96.8844Z"
      stroke="#6A266D"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="27"
      y="48.6797"
      width="28"
      height="43"
      fill="white"
      stroke="#6A266D"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M32 54H50V57H32V54Z"
      fill="#FDF5FF"
      stroke="#6A266D"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32 83H50V86H32V83Z"
      fill="#FDF5FF"
      stroke="#6A266D"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32 62H50V78H32V62Z"
      fill="#E6FBFF"
      stroke="#6A266D"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.813 43.9659L49.6229 43.9648"
      stroke="#79347F"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.9187 43C32.6697 43.0159 32.4362 43.1242 32.2656 43.3029C32.0949 43.4817 32 43.7175 32 43.9625C32 44.2075 32.0949 44.4433 32.2656 44.6221C32.4362 44.8008 32.6697 44.9091 32.9187 44.925C33.1677 44.9091 33.4012 44.8008 33.5718 44.6221C33.7425 44.4433 33.8374 44.2075 33.8374 43.9625C33.8374 43.7175 33.7425 43.4817 33.5718 43.3029C33.4012 43.1242 33.1677 43.0159 32.9187 43Z"
      fill="#6A266D"
    />
    <path
      d="M48 32H103V79C103 80.1046 102.105 81 101 81H50C48.8954 81 48 80.1046 48 79V32Z"
      fill="white"
    />
    <path
      d="M48 26C48 24.8954 48.8954 24 50 24H101C102.105 24 103 24.8954 103 26V33H48V26Z"
      fill="#FDF5FF"
    />
    <path
      d="M48 26.3203C48 25.2157 48.8954 24.3203 50 24.3203H101C102.105 24.3203 103 25.2157 103 26.3203V79.3203C103 80.4249 102.105 81.3203 101 81.3203H50C48.8954 81.3203 48 80.4249 48 79.3203V26.3203Z"
      stroke="#6A266D"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line x1="47.6521" y1="32.7656" x2="102.685" y2="32.7656" stroke="#6A266D" strokeWidth="1.25" />
    <ellipse
      cx="52.2936"
      cy="28.6963"
      rx="1.98913"
      ry="2.01266"
      fill="#FEE5E9"
      stroke="#6A266D"
      strokeWidth="1.25"
    />
    <ellipse
      cx="59.0873"
      cy="28.6963"
      rx="1.98913"
      ry="2.01266"
      fill="#FFF8D9"
      stroke="#6A266D"
      strokeWidth="1.25"
    />
    <ellipse
      cx="65.8807"
      cy="28.6963"
      rx="1.98913"
      ry="2.01266"
      fill="#E6FFF7"
      stroke="#6A266D"
      strokeWidth="1.25"
    />
    <path
      d="M53 38.3203H97V41.3203H53V38.3203Z"
      fill="#FDF5FF"
      stroke="#6A266D"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53 72.7891H97V75.7891H53V72.7891Z"
      fill="#FDF5FF"
      stroke="#6A266D"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43 46H108V68H43V46Z"
      fill="#E6FBFF"
      stroke="#6A266D"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M88 52H48"
      stroke="#6A266D"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M88 57H48"
      stroke="#6A266D"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M66 62H48"
      stroke="#6A266D"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M93 52H103V62H93V52Z"
      fill="white"
      stroke="#6A266D"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
